export const InvestorStatus = {
	InComplete: 'InComplete',
	Pending: 'Pending',
	ApprovedByAM: 'Compliance',
	ApprovedByCO: 'Approved',
	Archived: 'Archived',
	Blocked: 'Blocked',
	WindDown: 'Wind-down',
};
